// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"693":"67710a88","710":"c434d63b"}[chunkId] + ".chunk.js";
};